import React from 'react';
import mainlogo from '../logos/logomain.png';

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-gray-900 shadow-md transition-colors duration-300">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="flex flex-col md:flex-row items-center mb-6 md:mb-0">
            <img
              src={mainlogo}
              alt="ChowBuddy Logo"
              className="h-10 mb-4 md:mb-0 md:mr-4"
            />
            <a
              href="mailto:ranigboro@gmail.com"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 dark:hover:bg-purple-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition duration-300"
            >
              Contact Me
            </a>
          </div>
          <div className="flex flex-col md:flex-row items-center">
            <a
              href="https://www.buymeacoffee.com/rukywe"
              target="_blank"
              rel="noopener noreferrer"
              className="mb-4 md:mb-0 md:mr-6"
            >
              <img
                src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                alt="Buy Me A Coffee"
                className="h-10"
              />
            </a>
            <div className="flex space-x-6">
              <button
                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition duration-300"
                aria-label="Facebook"
              >
                <span className="sr-only">Facebook</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition duration-300"
                aria-label="Twitter"
              >
                <span className="sr-only">Twitter</span>
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 dark:border-gray-700 pt-8 text-center">
          <p className="text-gray-400 dark:text-gray-500 text-sm">
            © {new Date().getFullYear()} ChowBuddy. All rights reserved. Made
            with ❤️ by Rukywe.
          </p>
          <a
            href="https://www.aitechsuite.com/tools/16565?ref=featured&v=23"
            target="_blank"
            rel="nofollow noreferrer"
          >
            <img
              width="300"
              src="https://aitsmarketing.s3.amazonaws.com/aits-verified-tool.svg?width=600"
              alt="AI Tech Suite Verified Tool Badge"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
